const API = process.env.REACT_APP_BACKEND_URL;

// POSTs a message and parses the SSE stream from an assistant chat endpoint.
export async function streamAssistant(message, sessionId, { onSession, onDelta, onError }, path = '/api/assistant/chat') {
  try {
    const res = await fetch(`${API}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ message, session_id: sessionId }),
    });
    if (!res.ok || !res.body) {
      const data = await res.json().catch(() => ({}));
      onError(typeof data.detail === 'string' ? data.detail : 'Sorry — the assistant is unavailable right now. Please try again.', res.status);
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = '';
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      const parts = buf.split('\n\n');
      buf = parts.pop();
      for (const p of parts) {
        if (!p.startsWith('data: ')) continue;
        const ev = JSON.parse(p.slice(6));
        if (ev.type === 'session') onSession(ev.session_id, ev.remaining_today);
        else if (ev.type === 'delta') onDelta(ev.content);
        else if (ev.type === 'error') onError(ev.message);
      }
    }
  } catch {
    onError('Sorry — the assistant is unavailable right now. Please try again.');
  }
}
